import { SubscriptionTypes } from 'appConstants';
import { PackagePromo } from 'subscriptionOptions/types';

export type PackagesList = PackageGroup[];

export type PackageGroup = {
  name: string;
  description: string;
  subjects: Subjects[];
  classList?: any;
  selected?: string;
  subject?: string;
};

export type Subjects = {
  name: string;
  subscriptions: Package[];
};

export type Package = {
  packageID: number;
  packageIDs: number[];
  type: SubscriptionTypes.INVESTEMENT | SubscriptionTypes.STANDARD;
  price: number;
  promoCodeDiscount: number;
  subscribed: boolean;
  isAvailableForSchool: boolean;
  isFreeTrial: boolean;
  trialRemainingDays: number | null;
  ageGroup?: string;
  subject?: string;
  pricePerYear?: string;
};

export type PackagePricesList = PackagePrices[];

export type PackagePrices = {
  packagesID: number;
  discountedPrice: number;
  discountType: number;
  percentageOff: number;
  amountOff: number;
};

export interface IPromoCode {
  value: string;
  error: string;
}

export interface IPaymentTypes {
  poNumber: string;
  byCard: boolean;
  byInvoice: boolean;
  FinanceEmail: string;
}

export interface IPriceInfo {
  price: any;
  vat: any;
  total: any;
  discount: any;
  appliedDiscountType: any;
}

export enum NewSubscriptionStep {
  CHOOSE_PACKAGE,
  PAYMENT_TYPE,
  PAYMENT_DETAILS,
  CONFIRMATION,
}

export class NewSubscriptionParser {
  public static getPageHeaderInfo = (step: number) => {
    switch (step) {
      case NewSubscriptionStep.CHOOSE_PACKAGE:
        return {
          title: 'Choose your subscription length',
          nextStep: 'School details',
        };

      case NewSubscriptionStep.PAYMENT_TYPE:
        return {
          title: 'PaymentType',
          nextStep: 'Payment details / Confirmation',
        };

      case NewSubscriptionStep.PAYMENT_DETAILS:
        return { title: 'Payment details', nextStep: '' };

      case NewSubscriptionStep.CONFIRMATION:
        return { title: 'Confirmation', nextStep: '' };

      default:
        return { title: '', nextStep: '' };
    }
  };

  public static createEmptyPaymentType = (financeEmail: string | null) => ({
    poNumber: '',
    byCard: false,
    byInvoice: false,
    FinanceEmail: financeEmail ? financeEmail : '',
    firstName: '',
    lastName: '',
    emailAddress: '',
  });

  public static buildArchiveNowPayload = (
    packagePromos: PackagePromo[],
    expectedGrossAmount: number,
    poNumber: string,
    FinanceEmail: string,
    values: any,
    addSecondSchoolUser: boolean | null,
    chooseAddOrUpgrade: boolean | null,
    addSecondUserType: string
  ) => {
    if (
      (addSecondSchoolUser && !chooseAddOrUpgrade) ||
      (!addSecondSchoolUser &&
        chooseAddOrUpgrade &&
        addSecondUserType === 'manual')
    ) {
      return {
        expectedGrossAmount,
        packagePromos,
        poNumber,
        FinanceEmail,
        firstName: values.firstName,
        lastName: values.lastName,
        emailAddress: values.emailAddress,
        bAddSecondSchoolUser: addSecondSchoolUser,
        bChooseAddOrUpgrade: chooseAddOrUpgrade,
      };
    } else if (
      !addSecondSchoolUser &&
      chooseAddOrUpgrade &&
      addSecondUserType === 'existing'
    ) {
      return {
        expectedGrossAmount,
        packagePromos,
        poNumber,
        FinanceEmail,
        mainAccountHolderSchoolUsersId: parseInt(values.secondUserId),
        bAddSecondSchoolUser: addSecondSchoolUser,
        bChooseAddOrUpgrade: chooseAddOrUpgrade,
      };
    } else {
      return {
        expectedGrossAmount,
        packagePromos,
        poNumber,
        FinanceEmail,
        bAddSecondSchoolUser: addSecondSchoolUser,
        bChooseAddOrUpgrade: chooseAddOrUpgrade,
      };
    }
  };

  public static parseError = (errors: any) => {
    let error: string;
    switch (errors[0].messageCode) {
      case 'Missing_PromoCode':
        error = 'Promo code is missing';
        break;
      case 'Invalid_PromoCode':
        error = 'Invalid promo code';
        break;
      case 'No_valid_package_selected':
        error = 'The selected packages are invalid';
        break;
      case 'payment_amount_mismatch':
        error = 'Prices have changed. Please review your order and try again.';
        break;
      case 'pkey_general_invalid_payment_token':
        error = 'Sorry something went wrong. Please try again.';
        break;
      case 'Invalid_PromoCode_NotStarted':
        error = 'Invalid promocode ';
        break;
      case 'Invalid_PromoCode_Expired':
        error = 'Promo code is expired ';
        break;
      case 'Invalid_PromoCode_UsedAlready':
        error = 'Invalid promocode ';
        break;
      case 'Invalid_School_Account':
        error = 'Invalid school account';
        break;
      case 'Invalid_PackageID':
        error = 'Invalid packages';
        break;
      case 'Invalid_SubscriptionHistory':
        error = 'Invalid subscription history';
        break;
      case 'pkey_general_payment_card_error':
        error = 'Payment failed. Please try again.';
        break;
      case 'pkey_general_payment_error':
        error = 'Payment failed. Please try again.';
        break;
      case 'pkey_general_payment_subscription_failed':
        error = 'Payment failed. Please try again.';
        break;
      case 'pkey_general_payment_failed':
        error = 'Payment failed. Please try again.';
        break;
      case 'EmailAddress_Already_Exists':
        // AB#210773 - do not confirm whether the email is already registered (user enumeration).
        error =
          'We couldn’t complete your registration with those details. If you already have an account, please sign in or reset your password.';
        break;
      case 'Required':
        error = 'Sorry something went wrong. Please try again.';
        break;
      default:
        error = 'Sorry something went wrong. Please try again.';
    }
    return error;
  };
}
